import React, { useState } from "react";
import { Grid } from "@mui/material";
import { BlockDataGrid } from "../../Common/BlockDataGrid";
import {
  Accordion, AccordionSummary, AccordionDetails, Typography,
  Box, TextField, Button
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {CallCalibrate} from '../../../api/LVCCApi';

const Potentiometric = () => {
  const [gridData, setGridData] = useState([]);
  const [spline1GridData, setSpline1GridData] = useState([]);
  const [spline2GridData, setSpline2GridData] = useState([]);
  const [response, setResponse] = useState("{}");

  const [parameters, setParameters] = useState({
    assayNumber: "300",
    fKExponent: 2.0,
    fCalRepDeltaDRRange_1: 0.2,
    fCalRepDeltaDRRange_2: 0.2,
    fCalRepDeltaDRRange_3: 0.2
  });

  const handleGridDataChange = (newData) => {
    setGridData(newData);
  };

  const handleSpline1GridDataChange = (newData) => {
    setSpline1GridData(newData);
  };

  const handleSpline2GridDataChange = (newData) => {
    setSpline2GridData(newData);
  };

  const handleCalculate = () => {
    const getColumnValues = (gridData, columnKey) => {
      return columnKey ? gridData
        .map(row => parseFloat(row[columnKey]))
        .filter(val => !isNaN(val)) : [];
    };

    // Get Level and SAV pairs and remove duplicates
    const levelSavPairs = gridData
      .map(row => ({
        sCalLevel: parseInt(row["Level"]),
        fSAV: parseFloat(row["SAV"])
      }))
      .filter(pair => !isNaN(pair.sCalLevel) && !isNaN(pair.fSAV)) // Remove non-numeric entries
      .filter((pair, index, self) => 
        index === self.findIndex(p => 
          p.sCalLevel === pair.sCalLevel && p.fSAV === pair.fSAV
        )
      ); // Remove duplicates

    const apiPayload = {
      assayNumber: parameters.assayNumber,
      response1: getColumnValues(gridData, "Response 1"),
      levels: levelSavPairs,
      genInfo: {
        lAssayNumber: parameters.assayNumber,
        fPredictTime1: parameters.predictTime,
        fCalRepDeltaDRRange_1: parameters.fCalRepDeltaDRRange_1,
        fCalRepDeltaDRRange_2: parameters.fCalRepDeltaDRRange_2,
        fCalRepDeltaDRRange_3: parameters.fCalRepDeltaDRRange_3,
        fKExponent: parameters.fKExponent
      },
      spline: {
        xG1Spline: {
          sSplineNodeCount: getColumnValues(spline1GridData, "X").length,
          afX: getColumnValues(spline1GridData, "X"),
          afY1: getColumnValues(spline1GridData, "Y"),
          afY2: getColumnValues(spline1GridData, "Y2")
        },
        xG2Spline: {
          sSplineNodeCount: getColumnValues(spline2GridData, "X").length,
          afX: getColumnValues(spline2GridData, "X"),
          afY1: getColumnValues(spline2GridData, "Y"),
          afY2: getColumnValues(spline2GridData, "Y2")
        }
      },
    };

    console.log("API Call Payload:", JSON.stringify(apiPayload, null, 2));
    CallCalibrate.PM(apiPayload).then((r) => {
      console.log(r);
      setResponse(JSON.stringify(r.data));
    });
  }


  return (
    <div>
      <Typography variant="h6">Data</Typography>
      <p>Type or paste data into the below components</p>

      <Grid direction='row' container spacing={1}>
        <Grid container item sm={6}>
          <BlockDataGrid
            onDataChange={handleGridDataChange}
            columnNames={["Response 1", "Level", "SAV"]}
          />
        </Grid>
        <Grid container item sm={6}>
          <div style={{ width: '100%' }}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Spline 1</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <BlockDataGrid
                  onDataChange={handleSpline1GridDataChange}
                  columnNames={["X", "Y", "Y2"]}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Spline 2</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <BlockDataGrid
                  onDataChange={handleSpline2GridDataChange}
                  columnNames={["X", "Y", "Y2"]}
                />
              </AccordionDetails>
            </Accordion>
          </div>
        </Grid>
      </Grid>

      <Typography variant="h6" sx={{ mb: 1, pt: 2 }}>Parameters</Typography>
      <Box
        className="param"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2
        }}
      >

        {Object.entries(parameters).map(([key, value]) => (
          <Box key={key} sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <Typography variant="caption" sx={{ fontWeight: "bold", color: "gray" }}>
              {key}
            </Typography>
            <TextField
              type="number"
              value={value}
              onChange={(e) => setParameters({ ...parameters, [key]: e.target.value })}
              fullWidth
              variant="outlined"
              size="small"
            />
          </Box>))}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "right", mb: 3, pr: 5 }}>
        <Button variant="contained" color="primary" size="large" onClick={handleCalculate}>Calculate</Button>
      </Box>

      <Typography variant="h6">Output</Typography>
      <TextField multiline rows={6} value={response} fullWidth margin="dense" />


    </div>
  );
}

export default Potentiometric;